import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["date", "index", "isActive", "isDisabled", "month", "multiple", "onClick", "selectedValue", "withRange", "year", "firstDayOfWeek"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { bool, func, instanceOf, number, object, oneOfType, string } from 'prop-types';
import { getTime } from "../../../../utils/date";
import { getDayAtRange } from "../../../../utils/date/getters";
import styles from '../ScrollableCalendar.css';
var cx = classNames.bind(styles);

var checkIsDaySelected = function checkIsDaySelected(currentDayTime, dateValue, _ref) {
  var multiple = _ref.multiple,
      withRange = _ref.withRange;

  if (!dateValue) {
    return false;
  }

  if (withRange) {
    if (dateValue.from && dateValue.to) {
      return dateValue.from.getTime() <= currentDayTime && dateValue.to.getTime() >= currentDayTime;
    }

    if (dateValue.from) {
      return dateValue.from.getTime() === currentDayTime;
    }

    return false;
  }

  if (multiple) {
    return dateValue.some(function (date) {
      return date.getTime() === currentDayTime;
    });
  }

  return dateValue.getTime() === currentDayTime;
};

var getTimeByDay = function getTimeByDay(date) {
  return date ? new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() : 0;
};

export var Day = function Day(_ref2) {
  var date = _ref2.date,
      index = _ref2.index,
      isActive = _ref2.isActive,
      isDisabled = _ref2.isDisabled,
      month = _ref2.month,
      multiple = _ref2.multiple,
      onClick = _ref2.onClick,
      selectedValue = _ref2.selectedValue,
      withRange = _ref2.withRange,
      year = _ref2.year,
      firstDayOfWeek = _ref2.firstDayOfWeek,
      props = _objectWithoutProperties(_ref2, _excluded);

  var currentDayTime = getTimeByDay(date);

  var handleClick = function handleClick() {
    onClick(date);
  };

  var defineFirstDayInLayoutForRange = function defineFirstDayInLayoutForRange(day) {
    return !!(getDayAtRange(day, selectedValue) && day.getDay() === firstDayOfWeek);
  };

  var defineLastDayInLayoutForRange = function defineLastDayInLayoutForRange(day) {
    var lastDay = firstDayOfWeek === 0 ? 6 : 0;
    return !!(getDayAtRange(day, selectedValue) && day.getDay() === lastDay);
  };

  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: cx('Day', _objectSpread({
      Day_selected: checkIsDaySelected(currentDayTime, selectedValue, {
        withRange: withRange,
        multiple: multiple
      }),
      Day_disabled: isDisabled,
      Day_empty: date == null
    }, withRange && date ? {
      Day_inRange: getDayAtRange(date, selectedValue),
      Day_start: getTime(selectedValue.from) === getTime(date),
      Day_end: getTime(selectedValue.enteredTo) === getTime(date),
      Day_firstDayInLayout: defineFirstDayInLayoutForRange(date),
      Day_lastDayInLayout: defineLastDayInLayoutForRange(date)
    } : {})),
    key: "".concat(year, "_").concat(month, "_").concat(index),
    onClick: handleClick
  }, props), /*#__PURE__*/React.createElement("span", null, date ? date.getDate() : null));
};
Day.propTypes = process.env.NODE_ENV !== "production" ? {
  date: instanceOf(Date),
  firstDayOfWeek: number,
  handleClick: func,
  index: number,
  isActive: bool,
  // eslint-disable-line react/boolean-prop-naming
  isDisabled: bool,
  // eslint-disable-line react/boolean-prop-naming
  month: string,
  multiple: bool,
  onClick: func,
  selectedValue: oneOfType([instanceOf(Date), object]),
  withRange: bool,
  // eslint-disable-line react/boolean-prop-naming
  year: oneOfType([number, string])
} : {};